import { accountApi } from '@netiva/classifieds-api';

import { isNoCost } from '@/lib/utils';
import { useAppSelector } from '@/store';
import { useAd } from './useAd';

/**
 * Cost of the order being placed. The publication price shares its RTK Query cache entry with PriceSummary,
 * as both pass the same arguments.
 */
export const useAdPrice = () => {
  const { isPrintAdvert, price: printPrice } = useAd();
  const { selectedProductId, selectedExtensionProductIds, billingAddressId, contactAddressId, locationAddressId } =
    useAppSelector((state) => state.ad);

  const priceBillingAddressId = billingAddressId || contactAddressId || locationAddressId;
  const { data: publicationPrice } = accountApi.useCalculatePrice(
    {
      productId: selectedProductId,
      extensionProductIds: selectedExtensionProductIds,
      billingAddressId: priceBillingAddressId,
    },
    { skip: isPrintAdvert }
  );

  const amounts = isPrintAdvert
    ? printPrice && { netAmount: printPrice.amount, grossAmount: printPrice.grossAmount }
    : publicationPrice;

  // false until the price is known
  return { isFree: isNoCost(amounts), priceBillingAddressId };
};
